import {color} from "@khanacademy/wonder-blocks-tokens";

import media from "./media-queries.ts";

// We need either isMobile or isDesktop to be true at the same time. In Chrome,
// at non-standard zoom levels (e.g., 110%), [isMobile, isDesktop] =
// media.screen.breakAtWidth results in isMobile and isDesktop not being
// opposites.
export const isMobile: any = "@media screen and (max-width: 1023px)";
export const isDesktop: any = "@media screen and (min-width: 1023.5px)";

export const newBannerColors = {
    blue: color.darkBlue,
} as const;

export const is768OrLess: any = media.screen.and("(max-width: 768px)");

// For narrow mobile devices, we put the payment fields in rows and change
// some of the font sizes.
export const isNarrowMobile: any = media.screen.and("(max-width: 550px)");
